import mapboxgl from "mapbox-gl";

import { DRAWING_CONSTANTS } from "fond/constants";
import defaultStyles from "fond/draw/defaultStyles";
import { MapboxStyleLayer } from "fond/types";

const isValid = `user_${DRAWING_CONSTANTS.Valid}`;

/**
 * The MapboxDraw theme extended to include styles specific for lead-in features.
 */
const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  // Override the line styles to include hover effects
  if (style.id === "gl-draw-line-inactive") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-dasharray": [2, 2],
        "line-width": ["case", ["==", ["get", isValid], "false"], 4, 2],
        "line-color": [
          "case",
          ["==", ["get", "user_meta:hover"], "true"],
          "#1489EF",
          ["case", ["==", ["get", isValid], "false"], "red", "rgb(227, 10, 198)"],
        ],
      },
    } as mapboxgl.LineLayer;
  }

  if (style.id === "gl-draw-line-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-dasharray": [2, 2],
        "line-width": ["case", ["==", ["get", isValid], "false"], 4, 2],
        "line-color": ["case", ["==", ["get", isValid], "false"], "red", "yellow"],
      },
    } as mapboxgl.LineLayer;
  }

  // Override the color of the vertex & mid point colors
  if (
    [
      "gl-draw-point-active",
      "gl-draw-polygon-midpoint",
      "gl-draw-polygon-and-line-vertex-inactive",
      "gl-draw-polygon-and-line-vertex-stroke-inactive",
    ].includes(style.id)
  ) {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-color": "rgb(227, 10, 198)",
      },
    } as mapboxgl.CircleLayer;
  }

  return style;
});

export default modifiedDefaults;
